import { subject } from "@casl/ability"

import type { AclAction, AclSubject, AclSubjectMap, AclSubjectType, AppAbility } from "./types"


export const can = <TSubject extends Exclude<AclSubjectType, "all">>(
  ability: AppAbility,
  action: AclAction,
  subjectType: TSubject,
  object?: Partial<AclSubjectMap[TSubject]> | null,
): boolean => {
  if (object && typeof object === "object") {
    return ability.can(action, subject(subjectType, object) as unknown as AclSubject)
  }
  return ability.can(action, subjectType)
}
